<template lang="pug">
  div
    delivery-state-cards.mb-4
    .tabla.sombra
      b-form(@submit.stop.prevent="fetchData()")
        b-form-row(align-content="start")
          b-col.mb-2(cols="12")
            h3 {{ store ? '' : '' }} Envíos
          b-col.mb-2(cols="12" md="2")
            b-form-input(v-model="filterOptions.search" placeholder="buscar")
          b-col.mb-2(cols="12" md="2")
            b-form-select(v-model="filterOptions.state")
              b-form-select-option(:value="null") Selecciona un Estado
              b-form-select-option(:value="'NULL'") Por entregar
              b-form-select-option(:value="'entregado'") Entregado
              b-form-select-option(:value="'pendiente'") Pendiente
              b-form-select-option(:value="'rechazado'") Rechazado
              b-form-select-option(:value="'cancelado'") Cancelado
          b-col.mb-2(cols="12" md="2")
            b-form-select(v-model="filterOptions.pickedUpAtStore")
              b-form-select-option(:value="null") Recepción
              b-form-select-option(:value="true") Recepcionados
              b-form-select-option(:value="false") No recepcionados
          b-col.mb-2(cols="12" md="2")
            b-input-group()
              b-form-datepicker(
                label-no-date-selected="Desde"
                v-model="filterOptions.from"
                :date-format-options="{ 'year': 'numeric', 'month': 'numeric', 'day': 'numeric' }"
                reset-button
                today-button
                label-today-button="Hoy"
            )
          b-col.mb-2(cols="12" md="2")
            b-input-group()
              b-form-datepicker(
                label-no-date-selected="Hasta"
                v-model="filterOptions.to"
                :date-format-options="{ 'year': 'numeric', 'month': 'numeric', 'day': 'numeric' }"
                reset-button
                today-button
                label-today-button="Hoy"
            )
          b-col.mb-2(cols="12" md="auto")
            b-button(type="submit" block) Filtrar
          b-col.mb-2(cols="12" md="auto")
            b-button(v-b-modal.create-delivery-form-modal block) Ingresar Nuevo
          b-col.mb-2(cols="12" md="auto")
            b-button(v-b-modal.upload-deliveries-modal block) Importar Envíos
          b-col.mb-2(cols="12" md="auto")
            b-button(@click="exportExcel()" block) Exportar Excel
          b-col.mb-2(cols="12" md="auto")
            b-button(href="PlantillaCargaMasiva.xlsx") Descargar Plantilla
          b-col.mb-2(cols="12" md="auto")
            b-dropdown(text="Acciones")
              b-dropdown-item-button(@click="printSelectedPackages()") Imprimir Seleccionados
              b-dropdown-item-button(@click="bulkPrintByDate()") Impresión Masiva Por Fecha
      b-table(:fields="fields" :items="deliveryData" responsive )
        template(#head(select))
          b-form-checkbox(v-model="selectedAllIds" @change="toggleSelectAll")
        template(#cell(select)="{item}")
          b-form-checkbox(:value="item.id" v-model="selectedIds" @change="handlePackageToPrint(item.actions)")
        template(#cell(actions)="{value}")
          .botones-accion
            b-button.mr-2.mb-1.boton-ver(@click="$router.push(`/envio/${value.id}`)")
              .material-icons remove_red_eye
            b-button.mb-1.boton-imprimir(@click="printPackageLabel(value)")
              .material-icons print
        template(#cell(state)="{value}")
          div
            b-badge(v-if="value === 'Entregado'" variant="success") {{ value }}
            b-badge(v-else-if="value === 'Cancelado'" variant="cancelado") {{ value }}
            b-badge(v-else-if="value === 'Rechazado'" variant="danger") {{ value }}
            b-badge(v-else-if="value === 'Pendiente'" variant="warning").text-white {{ value }}
            b-badge(v-else variant="light") {{ value }}
        template(#cell(pickup)="{value, item}")
          div.pickup-cell
            span(:id="pickupBadgeId(item)")
              b-badge.pickup-badge(v-if="value === true" variant="success") Recepcionado
              b-badge.pickup-badge(v-else variant="danger") No recepcionado
            b-tooltip(v-if="value === true && item.pickedUpAtStoreAt" :target="pickupBadgeId(item)" triggers="hover" placement="top")
              .pickup-tooltip
                .pickup-tooltip__row
                  span.pickup-tooltip__label Fecha:
                  span.pickup-tooltip__value {{ formatPickupDate(item.pickedUpAtStoreAt) }}
      b-pagination-nav(
        align="center"
        :number-of-pages="totalPages ? totalPages : 1"
        :link-gen="linkGen"
        v-model="currentPage"
      )

    b-modal#create-delivery-form-modal(ref="createDeliveryFormModal" hide-footer :title="`Creando envío para el ${getDeliveryDate().format('DD/MM/YYYY')}`")
      delivery-form(@done="onDoneDeliveryModal")
    b-modal#upload-deliveries-modal(ref="updateDeliveryFormModal" title="Importar Envíos" ok-only @hide="isExcelErrors = true")
      upload-deliveries-from-exel(ref="uploadDeliveryFromExcelForm" @done="onDoneDeliveryModal" @errors="checkExcelErrors")
      template(#modal-footer="{close}")
        b-button(@click="$refs.uploadDeliveryFromExcelForm.onSubmit()" :disabled="isExcelErrors") Guardar envíos
        b-button(@click="close()" variant="outline-primary") Cancelar

    PrintAllPackagesLabel(ref="allPackagesLabelTemplate")
    PrintShippingLabels(ref="shippingLabels")
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import DeliveryStateCards from './DeliveryStateCards'
import DeliveryForm from './DeliveryForm.vue'
import UploadDeliveriesFromExel from './UploadDeliveriesFromExel.vue'
import PrintAllPackagesLabel from './printPackages/PrintAllPackagesLabel.vue'
import PrintShippingLabels from './printPackages/PrintShippingLabels.vue'

export default {
  props: {
    deliveryList: Array
  },
  components: {
    DeliveryStateCards,
    DeliveryForm,
    UploadDeliveriesFromExel,
    PrintAllPackagesLabel,
    PrintShippingLabels
  },
  data() {
    return {
      datepickerFormat: { year: 'numeric', month: 'numeric', day: 'numeric' },
      currentPage: 1,
      totalPages: null,
      selectedPackages: [],
      selectedAllIds: false,
      selectedIds: [],
      isExcelErrors: true,
      filterOptions: {
        from: null,
        to: null,
        search: '',
        page: 0,
        state: null,
        pickedUpAtStore: null,
        size: 50
      },
      fields: [
        { key: 'select' },
        { label: 'Id', key: 'id' },
        { label: 'Cliente', key: 'customerName' },
        { label: 'Dirección', key: 'address' },
        { label: 'Comuna', key: 'commune' },
        { label: 'Teléfono', key: 'customerPhone' },
        { label: 'Fecha', key: 'date' },
        { label: 'Estado', key: 'state' },
        { label: 'Recepcionado', key: 'pickup' },
        { label: 'Acciones', key: 'actions' }
      ]
    }
  },
  methods: {
    ...mapActions(['listDelivery', 'getStore', 'getCountStates', 'checkWithdrawalHour', 'getLabelsByIds', 'downloadStoreExcelDelivery']),
    async exportExcel() {
      const showError = message => this.$bvToast.toast(message, {
        title: 'Error',
        variant: 'danger',
        solid: true
      })
      const { from, to } = this.filters
      if (!from || !to) {
        return showError('Debe seleccionar un rango de fechas')
      }
      const rangeDays = moment(to).diff(moment(from), 'days')
      if (rangeDays < 0) {
        return showError('La fecha desde no puede ser mayor a la fecha hasta')
      }
      if (rangeDays > 60) {
        return showError('El rango de fechas no puede ser mayor a 60 días')
      }
      const params = { ...this.filters }
      delete params.page
      delete params.size
      const response = await this.downloadStoreExcelDelivery({ params })
      if (!response || response.status !== 200) {
        showError((response && response.data && response.data.message) || 'No se pudo descargar el Excel')
      }
    },
    toggleSelectAll(value) {
      if (value) {
        this.selectedIds = this.allDeliveryIds
        this.selectedPackages = [...this.deliveries]
      } else {
        this.selectedIds = []
        this.selectedPackages = []
      }
    },
    handlePackageToPrint(item) {
      // console.log(item)
      // console.log(item, 'item para imprimir', checked, 'value')
      const filtered = this.selectedPackages.filter((p) => p.id === item.id)
      if (filtered.length) {
        this.selectedPackages = this.selectedPackages.filter((p) => p.id !== item.id)
      } else {
        this.selectedPackages.push(item)
      }
      // console.log(this.selectedPackages, 'paquetes para imprimir')
    },
    getDeliveryDate() {
      const currentDate = this.$moment.tz('America/Santiago')
      const hours = currentDate.hours()
      // const minutes = currentDate.minutes()
      if (Number(hours) >= 13) {
        // const tomorrow = currentDate.add(1, 'days').format('YYYY-MM-DD')
        const tomorrow = currentDate.add(1, 'days')
        console.log('El delivery se enviará mañana: ', tomorrow.format('DD/MM/YYYY'))
        return tomorrow
        // return currentDate.format('YYYY-MM-DD')
      } else {
        console.log('El delivery se enviará hoy: ', currentDate.format('DD/MM/YYYY'))
        // return currentDate.format('YYYY-MM-DD')
        return currentDate
      }
    },
    linkGen(pageNum) {
      return {
        path: '/envios/',
        query: { page: pageNum }
      }
    },
    handleResize() {
      this.ancho = window.innerWidth
    },
    async fetchData() {
      const response = await this.listDelivery({ params: { ...this.filters } })
      this.getCountStates({ params: { ...this.filters } })
      if (response) {
        this.totalPages = response.data.totalPages
      }
      this.selectedAllIds = false
      this.toggleSelectAll(false)
    },
    onDoneDeliveryModal() {
      this.listDelivery({ params: { ...this.filters } })
      this.$refs.createDeliveryFormModal.hide()
      this.$refs.updateDeliveryFormModal.hide()
      this.$emit('done')
      this.fetchData()
    },
    printSelectedPackages() {
          const selectedPackages = this.selectedPackages
          if (selectedPackages.length === 0) {
            return this.$bvToast.toast('No hay envíos seleccionados', {
              title: 'Error',
              variant: 'danger',
              solid: true
            })
          }
          this.printLabelsByIds(selectedPackages.map(p => p.id), selectedPackages)
        },
        async bulkPrintByDate() {
          if (!this.filters.from || !this.filters.to) {
            return this.$bvToast.toast('Debe seleccionar un rango de fechas', {
              title: 'Error',
              variant: 'danger',
              solid: true
            })
          }

          await this.listDelivery({ params: { ...this.filters, size: 300 } })
          this.selectedPackages = [...this.deliveries]
          const selectedPackages = this.selectedPackages
          if (selectedPackages.length === 0) {
            return this.$bvToast.toast('No hay envíos para la fecha seleccionada', {
              title: 'Error',
              variant: 'danger',
              solid: true
            })
          }
          await this.printLabelsByIds(selectedPackages.map(p => p.id), selectedPackages)
          // this.selectedAllIds = false
          // this.toggleSelectAll(false)
          this.fetchData()
        },
        printPackageLabel(item) {
          this.printLabelsByIds([item.id], [item])
        },
        /**
         * spec 003: ver ListDelivery.vue#printLabelsByIds — mismo patrón.
         */
        async printLabelsByIds(ids, fallbackItems) {
          try {
            const response = await this.getLabelsByIds({ ids })
            if (response && response.status === 200 && Array.isArray(response.data) && response.data.length > 0) {
              this.$refs.shippingLabels.print(response.data)
              return
            }
            throw new Error('Respuesta vacía')
          } catch (err) {
            const contexts = (fallbackItems || []).map(p => this.getLabelContext(p))
            if (contexts.length === 0) {
              this.$bvToast.toast('No se pudo obtener la información de las etiquetas', {
                title: 'Error',
                variant: 'danger'
              })
              return
            }
            this.$refs.shippingLabels.print(contexts)
          }
        },
    getLabelContext(item) {
      // console.log(item, 'este es el objeto a imprimir')
      return {
        id: item.id,
        customerName: item.customerName,
        customerPhone: item.customerPhone,
        customerAddress: item.address.street,
        customerFullAddress: `${item.address.street}, ${item.address.commune}`,
        commentary: item.commentary,
        commune: item.address.commune,
        storeName: item.store.name,
        store: item.store,
        storeAddressStreet: item.store ? item.store.address.street : '',
        storeAddressStreetNumber: item.store ? item.store.address.streetNumber : '',
        storeAddressApartment: item.store ? item.store.address.apartment : '',
        storeAddressCommune: item.store ? item.store.address.commune : ''
      }
    },
    checkExcelErrors(value) {
      this.isExcelErrors = value
    },
    pickupBadgeId(item) {
      return `pickup-badge-${item.id}`
    },
    formatPickupDate(value) {
      if (!value) return '—'
      const m = this.$moment && this.$moment(value)
      return m && m.isValid() ? m.format('DD-MM-YYYY HH:mm') : String(value)
    }
  },
  computed: {
    ...mapGetters(['deliveries', 'store', 'user']),
    deliveryData() {
      let items = []
      if (this.deliveries) {
        items = this.deliveries.reduce((acum, delivery) => acum.concat({
          id: delivery.id,
          customerName: delivery.customerName,
          address: delivery.address.street,
          commune: delivery.address.commune,
          state: delivery.state ? delivery.state.replace(/^./, delivery.state[0].toUpperCase()) : 'Por entregar',
          date: this.$moment(delivery.date.substring(0, 10)).format('DD-MM-YYYY'),
          customerPhone: delivery.customerPhone,
          actions: delivery,
          pickup: delivery.pickedUpAtStore === true,
          pickedUpAtStoreAt: delivery.pickedUpAtStoreAt
        }), [])
      }
      return items
    },
    allDeliveryIds() { return this.deliveries.map(delivery => delivery.id) },
    filters() {
      const filter = {}
      for (const key in this.filterOptions) {
        if (this.filterOptions[key] !== null && this.filterOptions[key] !== '') {
          filter[key] = this.filterOptions[key]
        }
      }
      return filter
    }
  },
  created() {
    this.fetchData()
    this.getStore({ id: this.user.storeId })
    if (window.innerWidth < 650) {
      this.filterOptions.size = 6
    }
  },
  watch: {
    currentPage(valor) {
      this.filterOptions.page = valor - 1
      this.fetchData()
    }
  }
}
</script>
<style scoped>
.pickup-cell {
  display: flex;
  justify-content: center;
}

.pickup-badge {
  font-size: 0.8rem;
  padding: 0.4em 0.65em;
}

.pickup-tooltip {
  font-size: 0.85rem;
  line-height: 1.3;
  text-align: left;
}

.pickup-tooltip__row {
  display: flex;
  gap: 0.4rem;
  white-space: nowrap;
}

.pickup-tooltip__label {
  font-weight: 600;
  color: #ffffff;
}

.pickup-tooltip__value {
  color: #ffffff;
}
</style>
